const deepSeaBlue = {
    /**
     * Lighter shades (50 - 400)
     */
    50: '#e3e8e9',   // Much lighter shade
    100: '#c8d1d3',  // Very light shade
    200: '#aabadb',  // Lighter shade
    300: '#8d9ea2',  // Light shade
    400: '#72858c',  // Slightly light shade

    /**
     * Base color (500)
     */
    500: '#04121C',  // Base color

    /**
     * Darker shades (600 - 900)
     */
    600: '#031017',  // Slightly darker shade
    700: '#030f15',  // Darker shade
    800: '#020d12',  // Dark shade
    900: '#020b0f',  // Very dark shade

    /**
     * Accent shades (A100 - A700)
     */
    A100: '#2b3d3f', // Light accent
    A200: '#223536', // Normal accent
    A400: '#1a2d2f', // Dark accent
    A700: '#122526', // Very dark accent
};

export default deepSeaBlue;
